if (!customElements.get('hero-slideshow')) {
    class HeroSlideshow extends HTMLElement {
        constructor() {
            super();
            
        }
        connectedCallback() {
            this.initSwiper();
        }
        initSwiper() {
            const exclusiveSwiper = new Swiper(this.closest('[data-swiper-id="hero-slideshow"]'), {
                slidesPerView: 1,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            }) 
        }
    }

    customElements.define('hero-slideshow', HeroSlideshow);
}